import React from 'react';
import RoomSelect from '../../SearchForm/children/RoomSelect';
export const BedroomSelector = ({ onSelect, numberOfBedrooms = '', availableNumberOfBedrooms, handleGTMFilterChange, }) => {
    const innerOnChange = (value) => {
        onSelect(value);
        handleGTMFilterChange('number of bedrooms', `${value || 'any'} bedrooms`);
    };
    return (<div className='bl-haven-bedroomSelector'>
      <RoomSelect rooms={availableNumberOfBedrooms} value={numberOfBedrooms} onChange={innerOnChange}/>
    </div>);
};
